import React from "react";
import { useState } from "react";
import "./chat.css";
import chatuser from "../../assets/images/sidebar/userchat.png";
import Chatlogo from "../../assets/images/chat/chatLogo.png";
import Admin from "./Admin";
import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Badge from "@mui/material/Badge";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DashboardLayout from "../../layouts/Dashboard";
import LoupeIcon from "@mui/icons-material/Loupe";
import DashboardNavbar from "../../layouts/Navbars/DashboardNavbar";
const Chat = () => {
  const [state, setState] = useState({
    openNew: false,
  });

  const Sidebar = styled(Stack)({
    minHeight: "500px",
    boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.12)",
    background: "#FFFFFF",
    // width: "300px",
    borderRadius: "8px",
  });
  const Card = styled(Stack)({
    height: "60px",
    width: "234px",
    borderRadius: "8px",
    padding: "8px 10px 8px 10px",
    background: "#F8F8F8",
  });
  const NewConversation = styled(Stack)({
    minHeight: "300px",
    width: "300px",
    borderRadius: "8px",
    background: "#FFFFFF",
    zIndex: 7,
    padding: "20px",
    position: "absolute",
    color: "#67748E",
  });

  const theme = createTheme({
    palette: {
      primary: {
        light: "#04B2AE",
        main: "#04B2AE",
        dark: "#04B2AE",
        contrastText: "#fff",
        background: "#F8F8F8",
      },
    },
  });
  const openNewConversation = () => {
    setState((prev) => ({ ...prev, openNew: !prev.openNew }));
  };
  const commonStyles = {
    bgcolor: "background.paper",
    borderColor: "#EF9F57",
    m: 1,
    border: 1,
    width: "1.3rem",
    height: "1.3rem",
    color: "#EF9F57",
  };
  return (
    <DashboardLayout>
      <DashboardNavbar>
        <Grid container spacing={2}>
          <Grid item xs={1} sx={{ mx: 1 }}>
            <img src={Chatlogo} alt="img" />
          </Grid>
          <Grid
            item
            xs={9}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Chats
            </Typography>
          </Grid>
        </Grid>
      </DashboardNavbar>

      <Stack direction="row" sx={{ mt: 5 }}>
        <Sidebar sx={{ mx: 2 }}>
          <Stack direction="row" sx={{ p: 1 }}>
            <Stack alignItems="center">
              {/* <img src={ChatBubble} alt="bubble" width="30px" height="30px" /> */}
            </Stack>
            <input
              type="text"
              placeholder="Search"
              style={{ border: 0, background: "#F7F7F7", borderRadius: "4px" }}
            />
            <Button size="small" onClick={openNewConversation}>
              <Box
                sx={{
                  ...commonStyles,
                  borderRadius: "16px",

                  "&:hover": {
                    bgcolor: "#EF9F57",
                    borderColor: "#EF9F57",

                    color: "#FFFFFF",
                  },
                }}
              >
                <LoupeIcon
                  sx={{
                    "&:hover": {
                      // background: "#FFFFFF",
                    },
                  }}
                />
              </Box>

              {/* <img
                src={open ? HoverAdd : AddCompany}
                onMouseOver={() => setOpen(true)}
                onMouseOut={() => setOpen(false)}
                width="50px"
                height="30px"
                alt=""
              /> */}
            </Button>
          </Stack>
          <Stack alignItems="center" sx={{ mt: 2 }}>
            <Card direction="row" justifyContent="space-between" sx={{ m: 1 }}>
              <Stack direction="row">
                <img
                  src={chatuser}
                  alt="img"
                  width="40px"
                  height="40px"
                  style={{ borderRadius: "100px" }}
                />
                <Stack sx={{ mx: 1 }} justifyContent="center">
                  <Typography sx={{ fontWeight: "semibold" }}>
                    Mushtaq
                  </Typography>
                  <Typography variant="p">kese ho?</Typography>
                </Stack>
              </Stack>
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="p">12:01 pm</Typography>
                <Typography>
                  <ThemeProvider theme={theme}>
                    <Badge badgeContent={4} color="primary" />
                  </ThemeProvider>
                </Typography>
              </Stack>
            </Card>
            <Card direction="row" justifyContent="space-between" sx={{ m: 1 }}>
              <Stack direction="row">
                <img
                  src={chatuser}
                  alt="img"
                  width="40px"
                  height="40px"
                  style={{ borderRadius: "100px" }}
                />
                <Stack sx={{ mx: 1 }} justifyContent="center">
                  <Typography sx={{ fontWeight: "semibold" }}>
                    Mushtaq
                  </Typography>
                  <Typography variant="p">kese ho?</Typography>
                </Stack>
              </Stack>
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="p">12:01 pm</Typography>
                <Typography>
                  <ThemeProvider theme={theme}>
                    <Badge badgeContent={4} color="primary" />
                  </ThemeProvider>
                </Typography>
              </Stack>
            </Card>
            <Card direction="row" justifyContent="space-between" sx={{ m: 1 }}>
              <Stack direction="row">
                <img
                  src={chatuser}
                  alt="img"
                  width="40px"
                  height="40px"
                  style={{ borderRadius: "100px" }}
                />
                <Stack sx={{ mx: 1 }} justifyContent="center">
                  <Typography sx={{ fontWeight: "semibold" }}>
                    Mushtaq
                  </Typography>
                  <Typography variant="p">kese ho?</Typography>
                </Stack>
              </Stack>
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="p">12:01 pm</Typography>
                <Typography>
                  <ThemeProvider theme={theme}>
                    <Badge badgeContent={4} color="primary" />
                  </ThemeProvider>
                </Typography>
              </Stack>
            </Card>{" "}
            <Card direction="row" justifyContent="space-between" sx={{ m: 1 }}>
              <Stack direction="row">
                <img
                  src={chatuser}
                  alt="img"
                  width="40px"
                  height="40px"
                  style={{ borderRadius: "100px" }}
                />
                <Stack sx={{ mx: 1 }} justifyContent="center">
                  <Typography sx={{ fontWeight: "semibold" }}>
                    Mushtaq
                  </Typography>
                  <Typography variant="p">kese ho?</Typography>
                </Stack>
              </Stack>
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="p">12:01 pm</Typography>
                <Typography>
                  <ThemeProvider theme={theme}>
                    <Badge badgeContent={4} color="primary" />
                  </ThemeProvider>
                </Typography>
              </Stack>
            </Card>
          </Stack>
        </Sidebar>
        <Box className="w-75">
          {state.openNew && (
            <NewConversation alignItems="center">
              <Button sx={{ textTransform: "capitalize", color: "#67748E" }}>
                +Start new conversation
              </Button>
              <Card
                direction="row"
                justifyContent="space-between"
                sx={{ m: 1 }}
              >
                <Stack direction="row">
                  <img
                    src={chatuser}
                    alt="img"
                    width="40px"
                    height="40px"
                    style={{ borderRadius: "100px" }}
                  />
                  <Stack sx={{ mx: 1 }}>
                    <Typography sx={{ fontWeight: "semibold" }}>
                      Mushtaq
                    </Typography>
                    <Typography variant="p">musta1@gmail.com</Typography>
                  </Stack>
                </Stack>
              </Card>
              <Card
                direction="row"
                justifyContent="space-between"
                sx={{ m: 1 }}
              >
                <Stack direction="row">
                  <img
                    src={chatuser}
                    alt="img"
                    width="40px"
                    height="40px"
                    style={{ borderRadius: "100px" }}
                  />
                  <Stack sx={{ mx: 1 }}>
                    <Typography sx={{ fontWeight: "semibold" }}>
                      Mushtaq
                    </Typography>
                    <Typography variant="p">musta1@gmail.com</Typography>
                  </Stack>
                </Stack>
              </Card>
              <Card
                direction="row"
                justifyContent="space-between"
                sx={{ m: 1 }}
              >
                <Stack direction="row">
                  <img
                    src={chatuser}
                    alt="img"
                    width="40px"
                    height="40px"
                    style={{ borderRadius: "100px" }}
                  />
                  <Stack sx={{ mx: 1 }}>
                    <Typography sx={{ fontWeight: "semibold" }}>
                      Mushtaq
                    </Typography>
                    <Typography variant="p">musta1@gmail.com</Typography>
                  </Stack>
                </Stack>
              </Card>
              <Card
                direction="row"
                justifyContent="space-between"
                sx={{ m: 1 }}
              >
                <Stack direction="row">
                  <img
                    src={chatuser}
                    alt="img"
                    width="40px"
                    height="40px"
                    style={{ borderRadius: "100px" }}
                  />
                  <Stack sx={{ mx: 1 }}>
                    <Typography sx={{ fontWeight: "semibold" }}>
                      Mushtaq
                    </Typography>
                    <Typography variant="p">musta1@gmail.com</Typography>
                  </Stack>
                </Stack>
              </Card>
            </NewConversation>
          )}

          <Admin />
        </Box>
      </Stack>
    </DashboardLayout>
  );
};

export default Chat;
